import { configureStore } from '@reduxjs/toolkit';
import { loadState } from '../localStorage';
import authReducer from '../features/auth/authSlice';
import campaignReducer from '../features/campaign/campaignSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    campaign: campaignReducer,
  },
  preloadedState: loadState(),
});
